import { ErrorMessage, useFormikContext } from "formik";
import _ from "lodash";
import { default as React, useContext, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import KycApplicationContext from "../../../Context/KYCApplicationContext/KYCApplicationContext";
import { AddressProofEnum } from "../../../Enumeration/AddressProofEnum";
import { CountryEnum } from "../../../Enumeration/CountryEnum";
import { FileTypeEnum } from "../../../Enumeration/FileTypeEnum";
import { OptionsEnum } from "../../../Enumeration/OptionsEnum";
import { SessionKeyEnum } from "../../../Enumeration/SessionKeyEnum";
import { StylePropertiesEnum } from "../../../Enumeration/StylePropertiesEnum";
import { TagValueEnum } from "../../../Enumeration/TagValueEnum";
import { WorkflowTypeEnum } from "../../../Store/WorkflowTypeEnum";
import { changeFileNameExtension, isFilePdf } from "../../../Utils/FileUtils";
import {
  keyPersonalInfo,
  OKCANCEL,
  VIEW_MODE,
} from "../../../Utils/GlobalValues";
import CsplAchField from "../../CsplControls/CsplAch/CsplAchField";
import CsplDateField from "../../CsplControls/CsplDate/CsplDateField";
import CsplDragDrop from "../../CsplControls/CsplDragDrop/CsplDragDrop";
import CsplImage from "../../CsplControls/CsplImage/CsplImage";
import CsplLabel from "../../CsplControls/CsplLabel/CsplLabel";
import CsplBackDropLoading from "../../CsplControls/CsplLoader/CsplBackDropLoading";
import CsplNumberField from "../../CsplControls/CsplNumber/CsplNumber";
import CsplPreviewModal from "../../CsplControls/CsplPreviewModal/CsplPreviewModal";
import CsplRadioButtonField from "../../CsplControls/CsplRadioButton/CsplRadioButtonField";
import CsplTextBoxField from "../../CsplControls/CsplTextBox/CsplTextBoxField";
import PercentageComponent from "../../CsplControls/PercentageComponent/PercentageComponent";
import AlertModal from "../../CsplModal/AlertModal";
import TermsAndConditionModal from "../../CsplModal/TermsAndConditionModal";
import CountryResource from "../../Resources/CommonResources/CountryResource";
import FileResource from "../../Resources/CommonResources/FileResource";
import OcrExtractResource from "../../Resources/CommonResources/OcrExtractResource";
import PersonalDetailsResource from "../../Resources/PersonalDetailsResources/PersonalDetailsResource";
import AadhaarTermsAndConditions from "./AadhaarTermsAndConditions";
import "./PersonalInfoDetails.css";

function KeyPersonalInfo(props) {
  const { getCallBackUrlAadharXml, switchJourney } = PersonalDetailsResource();
  const [getOCRExtractFromProof] = OcrExtractResource();
  const { getCountryByShortName } = CountryResource();
  const [getUploadedContent] = FileResource();
  const { setFieldValue, setFieldTouched } = useFormikContext();
  const values = props.value;
  const [countryId, setCountryId] = useState();
  const [modifiedPermanentCountryId, setModifiedPermanentCountryId] =
    useState();
  const [clicked, setClicked] = useState(false);
  const [isAadharTacOpen, setIsAadharTacOpen] = useState(false);
  const [isSwitchToAdhaarAltOpen, setIsSwitchToAdhaarAltOpen] = useState(false);
  const [isOpenAlertMsg, setIsOpenAlertMsg] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [errorDescription, setErrorDescription] = useState("");
  const [isResetting, setIsResetting] = useState(false);
  const applicationContext = useContext(KycApplicationContext);
  let isDisabled = applicationContext.disableForm;
  let mode = applicationContext.mode;
  const { t } = useTranslation("common");
  const [termsAndConditionsAccepted, setTermsAndConditionsAccepted] =
    useState(false);
  const [permanentCountryID, setPermanentCountryId] = useState();
  const radioValueList = [OptionsEnum.Yes, OptionsEnum.No];
  const idfySupportedAddressProofTypes = [
    AddressProofEnum.AADHAAR,
    AddressProofEnum.DL,
    AddressProofEnum.PASSPORT,
    AddressProofEnum.VOTERID,
  ];
  const [previewCkycImage, setPreviewCkycImage] = useState();
  const [ckycImageFileName, setCkycImageFileName] = useState();
  const [ckycImageContent, setCkycImageContent] = useState();

  const [showDisabilityFields, setShowDisabilityFields] = useState(false);

  // check if cyc image details , and if the mode is view , if both conditions are satisfied then show the ckyc image
  function allowCKYCImageDetails() {
    return (
      mode &&
      mode === VIEW_MODE &&
      values &&
      values.personalInfoDTO &&
      values.personalInfoDTO.keyPersonalInfoDTO &&
      values.personalInfoDTO.keyPersonalInfoDTO.ckycImageDetailsDTOList &&
      values.personalInfoDTO.keyPersonalInfoDTO.ckycImageDetailsDTOList.length >
        0
    );
  }

  //ckyc image on-click handler
  function ckycImageOnclickHandler(event, CkycImageDetail) {
    //check whether image path is not empty, then get image content by path
    if (!_.isEmpty(CkycImageDetail.imagePath)) {
      getUploadedContent(CkycImageDetail.imagePath).then(
        (res) => {
          if (res !== null && res !== "") {
            //assign preview data
            assignCkycImagePreviewData(
              res,
              CkycImageDetail.imageSequenceNo +
                "." +
                CkycImageDetail.imageExtension,
              true,
            );
          }
        },
        (error) => {},
      );
    } else {
      //assign preview data
      assignCkycImagePreviewData(
        CkycImageDetail.imageData,
        CkycImageDetail.imageSequenceNo + "." + CkycImageDetail.imageExtension,
        true,
      );
    }
  }
  //on closing ckyc preview image
  function ckycImageOnCloseHandler() {
    assignCkycImagePreviewData("", "", false);
  }
  //assign preview data
  function assignCkycImagePreviewData(content, fileName, isPreview) {
    setCkycImageContent(content);
    setCkycImageFileName(fileName);
    setPreviewCkycImage(isPreview);
  }

  function openAadharXmlWindow(url) {
    const newWindow = window.open(url, "_self", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  }

  function getCallBackUrlForAadhaarXml() {
    getCallBackUrlAadharXml(
      sessionStorage.getItem(SessionKeyEnum.AppKey),
      applicationContext.currentHolder.entityTypeName,
    ).then(
      (res) => {
        if (res !== null && res.url !== "") {
          // open the aadhaar digilocker if the capture link is received
          openAadharXmlWindow(res.url);
        }

        setClicked(false);
      },
      (error) => {
        setClicked(false);
      },
    );
  }

  // on terms and condition accept
  function onTermsAndConditionAccept() {
    setTermsAndConditionsAccepted(true);
    //aadhar xml create orfile
    getCallBackUrlForAadhaarXml();
  }

  // set click as false
  function onAlertClose() {
    setClicked(false);
  }

  function onAdhaarAltClose() {
    setIsSwitchToAdhaarAltOpen(false);
  }

  function getAadhaarDetails(e) {
    e.preventDefault();
    if (clicked == false) {
      setClicked(true);
      if (
        (values &&
          values.personalInfoDTO &&
          values.personalInfoDTO.keyPersonalInfoDTO.aadhaarTcAccepted) ||
        termsAndConditionsAccepted
      ) {
        onTermsAndConditionAccept();
      } else {
        //set aadhaar tac is open
        setIsAadharTacOpen(true);
        setClicked(false);
      }
    }
  }

  //handling residential Country Change
  const handleResidentialCountryChange = (value) => {
    setFieldValue("personalInfoDTO.keyPersonalInfoDTO.residentialState", null);
  };
  //handling permanent country change
  const handlePermanentCountryChange = (value) => {
    setFieldValue("personalInfoDTO.keyPersonalInfoDTO.permanentState", null);
    if (
      values.personalInfoDTO.keyPersonalInfoDTO
        .isPermanentAddressSameAsCKYCAadhaar === OptionsEnum.Yes
    ) {
      setFieldValue(
        "personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentCountry",
        value,
      );
      onModifiedPermanentCountryChange(value);
    }
  };
  //handling permanent State change
  const handlePermanentStateChange = (value) => {
    if (
      values.personalInfoDTO.keyPersonalInfoDTO
        .isPermanentAddressSameAsCKYCAadhaar === OptionsEnum.Yes
    ) {
      setFieldValue(
        "personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentState",
        value,
      );
      onModifiedPermanentStateChange(value);
    }
  };
  // Handle Changes in Modified permanent address fields
  const onModifiedPermanentCountryChange = (value) => {
    setFieldValue(
      "personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentState",
      null,
    );
    if (isDefaultModifiedAddressToResidentialAddress()) {
      setFieldValue(
        "personalInfoDTO.keyPersonalInfoDTO.residentialCountry",
        value,
      );
      setFieldValue(
        "personalInfoDTO.keyPersonalInfoDTO.residentialState",
        null,
      );
    }
  };

  const onModifiedPermanentStateChange = (value) => {
    if (
      values.personalInfoDTO.keyPersonalInfoDTO
        .residentialAddressSameAsPermanentAddress === OptionsEnum.Yes
    ) {
      setFieldValue(
        "personalInfoDTO.keyPersonalInfoDTO.residentialState",
        value,
      );
    }
  };

  const onModifiedPermanentAddressLine1Change = (value) => {
    if (isDefaultModifiedAddressToResidentialAddress()) {
      setFieldValue(
        "personalInfoDTO.keyPersonalInfoDTO.residentialAddressLine1",
        value,
      );
    }
  };
  const onModifiedPermanentAddressLine2Change = (value) => {
    if (isDefaultModifiedAddressToResidentialAddress()) {
      setFieldValue(
        "personalInfoDTO.keyPersonalInfoDTO.residentialAddressLine2",
        value,
      );
    }
  };
  const onModifiedPermanentAddressLine3Change = (value) => {
    if (isDefaultModifiedAddressToResidentialAddress()) {
      setFieldValue(
        "personalInfoDTO.keyPersonalInfoDTO.residentialAddressLine3",
        value,
      );
    }
  };
  const onModifiedPermanentCityChange = (value) => {
    if (isDefaultModifiedAddressToResidentialAddress()) {
      setFieldValue(
        "personalInfoDTO.keyPersonalInfoDTO.residentialCity",
        value,
      );
    }
  };
  const onModifiedPermanentPincodeChange = (value) => {
    if (isDefaultModifiedAddressToResidentialAddress()) {
      setFieldValue(
        "personalInfoDTO.keyPersonalInfoDTO.residentialPinCode",
        value,
      );
    }
  };

  function isDefaultModifiedAddressToResidentialAddress() {
    return (
      values.personalInfoDTO.keyPersonalInfoDTO
        .residentialAddressSameAsPermanentAddress === OptionsEnum.Yes
    );
  }

  // Residential same as  permanent
  function residentialAddressHandler(event) {
    event.preventDefault();
    values.personalInfoDTO.keyPersonalInfoDTO.residentialAddressSameAsPermanentAddress =
      event.target.value;

    if (event.target.value === OptionsEnum.Yes) {
      setResidentialAddressDetails(
        values.personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentAddressLine1,
        values.personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentAddressLine2,
        values.personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentAddressLine3,
        values.personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentCity,
        values.personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentState,
        values.personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentCountry,
        values.personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentPinCode,
      );
    } else {
      setResidentialAddressDetails("", "", "", "", null, null, "");
    }
    assignKeyPersonalInfoDetails();
  }

  //permenent same as ckyc/aadhar
  function modifyPermanentAddressHandler(event) {
    event.preventDefault();
    setIsResetting(true);
    setErrorDescription("");
    if (event.target.value === OptionsEnum.Yes) {
      assignModifiedPermanentAddressAndDependantDetails(event.target.value);
    } else {
      clearModifiedPermanentAddressAndDependantDetails(event.target.value);
    }
  }

  /**
   * assign Modified Permanent Address And Dependant Details
   * @param {*} isPermanentAddressSameAsCKYCAadhaar
   */
  function assignModifiedPermanentAddressAndDependantDetails(
    isPermanentAddressSameAsCKYCAadhaar,
  ) {
    if (
      values &&
      values.personalInfoDTO &&
      values.personalInfoDTO.keyPersonalInfoDTO
    ) {
      values.personalInfoDTO.keyPersonalInfoDTO.isPermanentAddressSameAsCKYCAadhaar =
        isPermanentAddressSameAsCKYCAadhaar;

      values.personalInfoDTO.keyPersonalInfoDTO.addressProofType = null;

      setUploadData("", "");

      setModifiedPermanentAddressDetails(
        values.personalInfoDTO.keyPersonalInfoDTO.permanentAddressLine1,
        values.personalInfoDTO.keyPersonalInfoDTO.permanentAddressLine2,
        values.personalInfoDTO.keyPersonalInfoDTO.permanentAddressLine3,
        values.personalInfoDTO.keyPersonalInfoDTO.permanentCity,
        values.personalInfoDTO.keyPersonalInfoDTO.permanentState,
        values.personalInfoDTO.keyPersonalInfoDTO.permanentCountry,
        values.personalInfoDTO.keyPersonalInfoDTO.permanentPinCode,
      );

      if (isDefaultModifiedAddressToResidentialAddress()) {
        setResidentialAddressDetails(
          values.personalInfoDTO.keyPersonalInfoDTO.permanentAddressLine1,
          values.personalInfoDTO.keyPersonalInfoDTO.permanentAddressLine2,
          values.personalInfoDTO.keyPersonalInfoDTO.permanentAddressLine3,
          values.personalInfoDTO.keyPersonalInfoDTO.permanentCity,
          values.personalInfoDTO.keyPersonalInfoDTO.permanentState,
          values.personalInfoDTO.keyPersonalInfoDTO.permanentCountry,
          values.personalInfoDTO.keyPersonalInfoDTO.permanentPinCode,
        );
      }

      assignKeyPersonalInfoDetails();
    }
  }

  /**
   * clear Modified Permanent Address And Dependant Details
   *
   * @param {*} isPermanentAddressSameAsCKYCAadhaar
   */
  function clearModifiedPermanentAddressAndDependantDetails(
    isPermanentAddressSameAsCKYCAadhaar,
  ) {
    if (
      values &&
      values.personalInfoDTO &&
      values.personalInfoDTO.keyPersonalInfoDTO
    ) {
      values.personalInfoDTO.keyPersonalInfoDTO.isPermanentAddressSameAsCKYCAadhaar =
        isPermanentAddressSameAsCKYCAadhaar;

      values.personalInfoDTO.keyPersonalInfoDTO.addressProofType = null;

      ClearModifiedPermanentAddressDetails();

      assignKeyPersonalInfoDetails();
    }
  }

  //assigning modified permanent address details
  function setModifiedPermanentAddressDetails(
    addressLine1,
    addressLine2,
    addressLine3,
    city,
    state,
    country,
    pincode,
  ) {
    values.personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentAddressLine1 =
      addressLine1;
    values.personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentAddressLine2 =
      addressLine2;
    values.personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentAddressLine3 =
      addressLine3;
    values.personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentCity = city;
    values.personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentState = state;
    values.personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentCountry =
      country;
    values.personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentPinCode =
      pincode;
  }

  //assigning residential address details
  function setResidentialAddressDetails(
    addressLine1,
    addressLine2,
    addressLine3,
    city,
    state,
    country,
    pincode,
  ) {
    values.personalInfoDTO.keyPersonalInfoDTO.residentialAddressLine1 =
      addressLine1;
    values.personalInfoDTO.keyPersonalInfoDTO.residentialAddressLine2 =
      addressLine2;
    values.personalInfoDTO.keyPersonalInfoDTO.residentialAddressLine3 =
      addressLine3;
    values.personalInfoDTO.keyPersonalInfoDTO.residentialCity = city;
    values.personalInfoDTO.keyPersonalInfoDTO.residentialState = state;
    values.personalInfoDTO.keyPersonalInfoDTO.residentialCountry = country;
    values.personalInfoDTO.keyPersonalInfoDTO.residentialPinCode = pincode;
  }

  //clearing modified permanent address data
  function ClearModifiedPermanentAddressDetails() {
    setModifiedPermanentAddressDetails("", "", "", "", null, null, "");
    if (isDefaultModifiedAddressToResidentialAddress()) {
      setResidentialAddressDetails("", "", "", "", null, null, "");
    }
  }

  //assign KeyPersonal Info Details
  function assignKeyPersonalInfoDetails() {
    setTimeout(() => {
      setFieldValue(
        "personalInfoDTO.keyPersonalInfoDTO",
        values.personalInfoDTO.keyPersonalInfoDTO,
        false,
      );
      setFieldTouched("personalInfoDTO.keyPersonalInfoDTO", false);
    }, 10);
  }

  //set upload data
  function setUploadData(base64String, fileName) {
    values.personalInfoDTO.keyPersonalInfoDTO.addressProofImage = base64String;
    values.personalInfoDTO.keyPersonalInfoDTO.addressProofFileName = fileName;
    values.personalInfoDTO.keyPersonalInfoDTO.addressProofPath = "";
  }
  //clear upload dependent data
  function clearUploadDependancyData() {
    setUploadData("", "");
    ClearModifiedPermanentAddressDetails();
    assignKeyPersonalInfoDetails();
    setTimeout(() => {
      setFieldTouched(
        "personalInfoDTO.keyPersonalInfoDTO.addressProofImage",
        true,
      );
    }, 10);
  }

  //handling address proof type
  const handleAddressProofTypeChange = (value) => {
    setIsResetting(true);
    setErrorDescription("");
    values.personalInfoDTO.keyPersonalInfoDTO.addressProofType = value;
    setUploadData("", "");
    ClearModifiedPermanentAddressDetails();
    assignKeyPersonalInfoDetails();
    if (value != null) {
    } else {
      setIsOpenAlertMsg(true);
      setAlertMsg(t("keyPersonalInfo.Please-select-address-proof-type"));
    }
  };

  /**
   * get Ocr Extracted Detail From File
   * @param  file
   */
  function getOcrExtractedDetailFromFile(file) {
    let ocrPromise = new Promise(function (onSuccess, onError) {
      getOCRExtractFromProof(
        applicationContext.currentHolder.entityTypeShortName,
        values.personalInfoDTO.keyPersonalInfoDTO.addressProofType.shortName,
        file,
        false,
      ).then(
        (res) => {
          //if error description is present then pass success response
          if (
            res !== null &&
            res.errorDescription !== null &&
            res.errorDescription !== ""
          ) {
            onSuccess(res);
          }
          //else assign error description as empty
          else {
            OcrResultBindingHandler(
              res,
              values.personalInfoDTO.keyPersonalInfoDTO.addressProofType
                .shortName,
            );
            setErrorDescription("");
            onSuccess(res);
          }
        },
        (error) => {
          setErrorDescription(error);
          onError(error);
        },
      );
    });

    return ocrPromise;
  }

  /**
   * get Masked Aadhar From Aadhar
   * @param file
   */
  function getMaskedAadharFromAadhar(file) {
    let aadharMaskingPromise = new Promise(function (onSuccess, onError) {
      getOCRExtractFromProof(
        applicationContext.currentHolder.entityTypeShortName,
        TagValueEnum.AADHAARMASKING,
        file,
        true,
      ).then(
        (res) => {
          if (!_.isEmpty(res.maskedAadharAsBase64)) {
            onSuccess(res.maskedAadharAsBase64);
          } else {
            onError(res);
          }
        },
        (error) => {
          onError(error);
        },
      );
    });

    return aadharMaskingPromise;
  }

  /**
   * on address proof upload
   * @param {*} file
   * @returns
   */
  function onAddressProofUpload(file, imageBase64, fileName) {
    setUploadData("", "");
    ClearModifiedPermanentAddressDetails();
    assignKeyPersonalInfoDetails();
    setIsResetting(false);
    let saveWidgetPromise = new Promise(function (onSuccess, onError) {
      if (
        file &&
        idfySupportedAddressProofTypes.includes(
          values.personalInfoDTO.keyPersonalInfoDTO.addressProofType.shortName,
        ) === true
      ) {
        extractDetailsFromImageUsingOCR(
          file,
          imageBase64,
          fileName,
          onSuccess,
          onError,
        );
      } else {
        setUploadData(imageBase64, fileName);
        assignKeyPersonalInfoDetails();
        onSuccess({ content: imageBase64, fileName: fileName });
      }
    });

    return saveWidgetPromise;
  }

  function extractDetailsFromImageUsingOCR(
    file,
    imageBase64,
    fileName,
    onSuccess,
    onError,
  ) {
    getOcrExtractedDetailFromFile(file).then(
      (response) => {
        if (
          values.personalInfoDTO.keyPersonalInfoDTO.addressProofType
            .shortName === AddressProofEnum.AADHAAR
        ) {
          getMaskedAadharFromAadhar(file).then(
            (result) => {
              var fileObj = {};
              fileObj.content = result;

              // if masked file is pdf then change the file type to JPEG
              // because for masked pdf data they provide jpeg data to us
              // for other type same type is received
              fileObj.fileName = isFilePdf(fileName)
                ? changeFileNameExtension(
                    fileName,
                    FileTypeEnum.JPEG.toLowerCase(),
                  )
                : fileName;

              setUploadData(fileObj.content, fileObj.fileName);
              assignKeyPersonalInfoDetails();
              onSuccess(fileObj);
            },
            (error) => {
              setUploadData(imageBase64, fileName);
              assignKeyPersonalInfoDetails();
              onSuccess({ content: imageBase64, fileName: fileName });
            },
          );
        } else {
          setUploadData(imageBase64, fileName);
          assignKeyPersonalInfoDetails();
          onSuccess({ content: imageBase64, fileName: fileName });
        }
      },
      (errorResponse) => {
        onError(t("AddressChange.pleaseUploadValidAddressProof"));
      },
    );
  }

  /*OCR Result binding handler */
  function OcrResultBindingHandler(result, shortName) {
    setDefaultCountryByShortName(CountryEnum.INDIA);
    values.personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentCity =
      result.district;
    values.personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentPinCode =
      result.pinCode;

    if (
      shortName === AddressProofEnum.VOTERID ||
      shortName === AddressProofEnum.AADHAAR
    ) {
      values.personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentAddressLine1 =
        result.houseNumber;
      values.personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentAddressLine2 =
        result.address;

      if (isDefaultModifiedAddressToResidentialAddress()) {
        values.personalInfoDTO.keyPersonalInfoDTO.residentialAddressLine1 =
          result.houseNumber;
        values.personalInfoDTO.keyPersonalInfoDTO.residentialAddressLine2 =
          result.address;
        values.personalInfoDTO.keyPersonalInfoDTO.residentialCity =
          result.district;
        values.personalInfoDTO.keyPersonalInfoDTO.residentialPinCode =
          result.pinCode;
        //"result.pinCode"
      }
    }
    if (
      shortName === AddressProofEnum.PASSPORT ||
      shortName === AddressProofEnum.DL
    ) {
      values.personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentAddressLine1 =
        result.address;

      if (isDefaultModifiedAddressToResidentialAddress()) {
        values.personalInfoDTO.keyPersonalInfoDTO.residentialAddressLine1 =
          result.address;
        values.personalInfoDTO.keyPersonalInfoDTO.residentialCity =
          result.district;
        values.personalInfoDTO.keyPersonalInfoDTO.residentialPinCode =
          result.pinCode;
      }
    }
  }

  /**
   * get country by short name
   * @param {*} shortname
   */
  function setDefaultCountryByShortName(shortname) {
    getCountryByShortName(shortname).then(
      (res) => {
        values.personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentCountry =
          res;
        if (isDefaultModifiedAddressToResidentialAddress()) {
          values.personalInfoDTO.keyPersonalInfoDTO.residentialCountry = res;
        }
        return res;
      },
      (error) => {},
    );
  }

  /* Switch To Adhaar */
  function switchToAdhaar(e) {
    e.preventDefault();
    if (clicked == false) {
      setClicked(true);
      setIsSwitchToAdhaarAltOpen(true);
    }
  }

  /* Switching to Adhaar */
  function onSwitchToAdhaar() {
    switchJourney(
      sessionStorage.getItem(SessionKeyEnum.KycApplicationId),
      applicationContext.currentHolder.entityTypeShortName,
      sessionStorage.getItem(SessionKeyEnum.AppKey),
    ).then(
      (res) => {
        props.setIsLoadingData(true);
        sessionStorage.setItem(
          SessionKeyEnum.HolderType,
          applicationContext.currentHolder.entityTypeShortName,
        );
        sessionStorage.setItem(
          SessionKeyEnum.ProfileStatusType,
          keyPersonalInfo,
        );

        props.getApplicationDetails();
        setClicked(false);
      },
      (error) => {
        setClicked(false);
      },
    );
  }

  const handleDifferentlyAbled = (event) => {
    let value = event.target.value;

    if (value === "") {
      value = null;
    }

    setShowDisabilityFields(value === OptionsEnum.Yes);

    setFieldValue(
      "personalInfoDTO.keyPersonalInfoDTO.isDifferentlyAbled",
      value,
      false,
    );

    // Clear disability fields when user selects "No"
    if (value === OptionsEnum.No) {
      setFieldValue(
        "personalInfoDTO.keyPersonalInfoDTO.impairmentTypeTagValue",
        null,
        false,
      );
      setFieldValue(
        "personalInfoDTO.keyPersonalInfoDTO.impairmentPercentage",
        "",
        false,
      );
      setFieldValue("personalInfoDTO.keyPersonalInfoDTO.udidNumber", "", false);
      setFieldValue(
        "personalInfoDTO.keyPersonalInfoDTO.impairmentFileUploadDTO.impairmentProofFile",
        null,
        false,
      );
      setFieldValue(
        "personalInfoDTO.keyPersonalInfoDTO.impairmentFileUploadDTO.impairmentProofFileName",
        null,
        false,
      );
      setFieldValue(
        "personalInfoDTO.keyPersonalInfoDTO.impairmentFileUploadDTO.impairmentProofFilePath",
        null,
        false,
      );
    }
  };

  const syncDisabilityFieldsVisibility = () => {
    const isYes =
      values?.personalInfoDTO?.keyPersonalInfoDTO?.isDifferentlyAbled ===
      OptionsEnum.Yes;

    if (isYes && !showDisabilityFields) {
      setShowDisabilityFields(true);
    }

    if (!isYes && showDisabilityFields) {
      setShowDisabilityFields(false);
    }
  };
  syncDisabilityFieldsVisibility();

  return (
    <React.Fragment>
      {/*  <form className="form-group form_body me-2 ms-2"> */}

      {/* Terms and condition */}
      {isAadharTacOpen && (
        <TermsAndConditionModal
          isModalOpen={isAadharTacOpen}
          setIsModalOpen={setIsAadharTacOpen}
          onAgreed={onTermsAndConditionAccept}
          onTacClose={onAlertClose}
          title={"termsAndCondition.aadhaarTACTitle"}
        >
          <AadhaarTermsAndConditions />
        </TermsAndConditionModal>
      )}

      {/* Alert */}
      {isSwitchToAdhaarAltOpen && (
        <AlertModal
          isModalOpen={isSwitchToAdhaarAltOpen}
          setIsModalOpen={setIsSwitchToAdhaarAltOpen}
          businessProcess={onSwitchToAdhaar}
          title={"modal.alertModalTitle"}
          type={OKCANCEL}
          onTacClose={onAlertClose}
        >
          {t("keyPersonalInfo.switchToAdhaarAltText")}
        </AlertModal>
      )}
      <div className="content_body">
        {(values &&
          values.personalInfoDTO &&
          values.personalInfoDTO.keyPersonalInfoDTO &&
          values.personalInfoDTO.keyPersonalInfoDTO.aadhaarDetailsUploadDate !=
            null) ||
        mode == VIEW_MODE ||
        (applicationContext.currentWorkflow !== null &&
          applicationContext.currentWorkflow.workflowDisplayName ===
            WorkflowTypeEnum.CKYC) ? (
          <div className="row">
            {applicationContext.currentWorkflow !== null &&
              applicationContext.currentWorkflow.workflowDisplayName ===
                WorkflowTypeEnum.AADHAAR &&
              !applicationContext.disableForm && (
                <>
                  <div className="col-lg-8 col-sm-11 col-12 mb-4 mx-auto aadhaar-xml-link ">
                    <a
                      onClick={(e) => getAadhaarDetails(e)}
                      className="btn shadow-none aadhaar-xml-btn p-0"
                    >
                      <CsplLabel label="keyPersonalInfo.downloadAadharDetailsText"></CsplLabel>
                    </a>
                    {values.personalInfoDTO &&
                      values.personalInfoDTO.keyPersonalInfoDTO &&
                      values.personalInfoDTO.keyPersonalInfoDTO
                        .aadhaarInfoMismatchRemarks != null && (
                        <div className="aadhaar_info_mismatch_container">
                          <span className="aadhaar_info_mismatch_remarks">
                            {
                              values.personalInfoDTO.keyPersonalInfoDTO
                                .aadhaarInfoMismatchRemarks
                            }
                          </span>
                        </div>
                      )}
                    {clicked && (
                      <CsplBackDropLoading
                        showLoading={clicked}
                      ></CsplBackDropLoading>
                    )}
                    <div>
                      <span className="file_instruction">
                        {t("keyPersonalInfo.getAadhaarDetailsHelpText")}
                      </span>
                    </div>
                  </div>
                </>
              )}

            {/* Overall width control */}
            {values &&
            values.personalInfoDTO &&
            values.personalInfoDTO.keyPersonalInfoDTO &&
            values.personalInfoDTO.keyPersonalInfoDTO
              .aadhaarInfoMismatchRemarks ? (
              <></>
            ) : (
              <div className="col-lg-8 col-sm-11 col-12 mx-auto ">
                {/* Prefix One Column Approach */}

                <div className="col-sm-11 col-12 mb-4 me-auto">
                  <div className="d-flex justify-content-between">
                    <div className="w-50 me-3 ">
                      <CsplAchField
                        label={"keyPersonalInfo.prefix"}
                        name="personalInfoDTO.keyPersonalInfoDTO.title"
                        required={true}
                        lookupName="salutations"
                        displayColumn="shortName"
                        idColumn="id"
                        id="title"
                        disabled={isDisabled}
                      />
                    </div>
                    <div className="w-100">
                      <CsplTextBoxField
                        label={"keyPersonalInfo.firstName"}
                        name="personalInfoDTO.keyPersonalInfoDTO.firstName"
                        required={true}
                        disabled={true}
                        id="firstName"
                      />
                    </div>
                  </div>
                </div>

                {/* Two Column approach */}

                {/* Two Column Approach */}

                <div className="col-sm-11 col-12 mb-4 me-auto">
                  <div className="d-md-flex justify-content-between">
                    <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                      <CsplTextBoxField
                        label={"keyPersonalInfo.middleName"}
                        name="personalInfoDTO.keyPersonalInfoDTO.middleName"
                        required={false}
                        disabled={true}
                        id="middleName"
                      />
                    </div>
                    <div className="w-100">
                      <CsplTextBoxField
                        label={"keyPersonalInfo.lastName"}
                        name="personalInfoDTO.keyPersonalInfoDTO.lastName"
                        required={false}
                        disabled={true}
                        id="lastName"
                      />
                    </div>
                  </div>
                </div>

                {/* One Column Appproach */}

                <div className="col-sm-11 col-12 mb-4 me-auto">
                  <CsplTextBoxField
                    label={"keyPersonalInfo.motherName"}
                    name="personalInfoDTO.keyPersonalInfoDTO.motherName"
                    required={true}
                    disabled={isDisabled}
                    id="motherName"
                  />
                </div>
                <div className="col-sm-11 col-12 mb-4 me-auto">
                  <div className="d-md-flex justify-content-between">
                    <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                      <CsplDateField
                        label={"keyPersonalInfo.dateOfBirth"}
                        name="personalInfoDTO.keyPersonalInfoDTO.dateOfBirth"
                        required={true}
                        disabled={true}
                        id="dateOfBirth"
                      />
                    </div>
                    <div className="w-100"></div>
                  </div>
                </div>

                {/* permanent Address */}
                <div className="col-sm-11 col-12 mb-4 me-auto text-left">
                  <p className="sub_header_label">
                    {" "}
                    {t("keyPersonalInfo.permanent-Address")}{" "}
                  </p>
                </div>

                <div className="col-sm-11 col-12 mb-4 me-auto">
                  <CsplTextBoxField
                    label={"keyPersonalInfo.AddressLine1"}
                    name="personalInfoDTO.keyPersonalInfoDTO.permanentAddressLine1"
                    required={false}
                    disabled={true}
                    id="permanentAddressLine1"
                  />
                </div>

                <div className="col-sm-11 col-12 mb-4 me-auto">
                  <CsplTextBoxField
                    label={"keyPersonalInfo.AddressLine2"}
                    name="personalInfoDTO.keyPersonalInfoDTO.permanentAddressLine2"
                    required={false}
                    disabled={true}
                    id="permanentAddressLine2"
                  />
                </div>

                <div className="col-sm-11 col-12 mb-4 me-auto">
                  <CsplTextBoxField
                    label={"keyPersonalInfo.AddressLine3"}
                    name="personalInfoDTO.keyPersonalInfoDTO.permanentAddressLine3"
                    required={false}
                    disabled={true}
                    id="permanentAddressLine3"
                  />
                </div>

                {/* Two Column Approach */}

                <div className="col-sm-11 col-12 mb-4 me-auto">
                  <div className="d-md-flex justify-content-between">
                    <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                      <CsplTextBoxField
                        label={"keyPersonalInfo.City"}
                        name="personalInfoDTO.keyPersonalInfoDTO.permanentCity"
                        required={true}
                        disabled={true}
                        id="permanentCity"
                      />
                    </div>
                    <div className="w-100">
                      <CsplAchField
                        label="keyPersonalInfo.Country"
                        name="personalInfoDTO.keyPersonalInfoDTO.permanentCountry"
                        required={true}
                        lookupName="country"
                        displayColumn="name"
                        idColumn="id"
                        id="permanentCountry"
                        disabled={isDisabled}
                        getIdValue={setPermanentCountryId}
                        onValueChange={handlePermanentCountryChange}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-sm-11 col-12 mb-4 me-auto">
                  <div className="d-md-flex justify-content-between">
                    <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                      <CsplAchField
                        label="keyPersonalInfo.State"
                        name="personalInfoDTO.keyPersonalInfoDTO.permanentState"
                        required={true}
                        lookupName="state"
                        displayColumn="name"
                        idColumn="id"
                        id="correspondenceState"
                        disabled={isDisabled}
                        filterValue={permanentCountryID}
                        onValueChange={handlePermanentStateChange}
                      />
                    </div>
                    <div className="w-100">
                      <CsplTextBoxField
                        label={"keyPersonalInfo.PinCode"}
                        name="personalInfoDTO.keyPersonalInfoDTO.permanentPinCode"
                        required={true}
                        disabled={true}
                        id="permanentPinCode"
                      />
                    </div>
                  </div>
                </div>

                {/*Permanent Address Change*/}
                <div className="col-sm-11 col-12 mb-4 me-auto">
                  <CsplRadioButtonField
                    valuelist={radioValueList}
                    disabled={isDisabled}
                    rowdisplay={true}
                    label={"keyPersonalInfo.permanentAddressSameAsCkycAadhar"}
                    name="personalInfoDTO.keyPersonalInfoDTO.isPermanentAddressSameAsCKYCAadhaar"
                    onChange={modifyPermanentAddressHandler}
                    defaultValue={OptionsEnum.Yes}
                    defaultvaluedependencyhandler={
                      assignModifiedPermanentAddressAndDependantDetails
                    }
                  ></CsplRadioButtonField>
                </div>

                {values &&
                  values.personalInfoDTO &&
                  values.personalInfoDTO.keyPersonalInfoDTO &&
                  values.personalInfoDTO.keyPersonalInfoDTO
                    .isPermanentAddressSameAsCKYCAadhaar &&
                  values.personalInfoDTO.keyPersonalInfoDTO
                    .isPermanentAddressSameAsCKYCAadhaar === OptionsEnum.No && (
                    <>
                      <div className="col-sm-11 col-12 mb-4 me-auto text-left">
                        <p className="sub_header_label">
                          {" "}
                          {t("keyPersonalInfo.addressChange")}{" "}
                        </p>
                      </div>

                      <div className="col-sm-11 col-12 mb-4 me-auto">
                        <CsplAchField
                          label="keyPersonalInfo.addressProofType"
                          name="personalInfoDTO.keyPersonalInfoDTO.addressProofType"
                          required={true}
                          lookupName="addressProof"
                          displayColumn="name"
                          idColumn="id"
                          id="addressProofType"
                          disabled={isDisabled}
                          onValueChange={handleAddressProofTypeChange}
                        />

                        <AlertModal
                          isModalOpen={isOpenAlertMsg}
                          setIsModalOpen={setIsOpenAlertMsg}
                          modalWidth={StylePropertiesEnum.sm}
                          title={"keyPersonalInfo.alert"}
                          type={StylePropertiesEnum.OK}
                        >
                          {alertMsg}
                        </AlertModal>
                      </div>

                      <div className="col-sm-11 col-12 mb-4 me-auto">
                        <CsplDragDrop
                          label={"keyPersonalInfo.addressProofUpload"}
                          required={true}
                          disabled={
                            isDisabled ||
                            !(
                              values &&
                              values.personalInfoDTO &&
                              values.personalInfoDTO.keyPersonalInfoDTO &&
                              values.personalInfoDTO.keyPersonalInfoDTO
                                .addressProofType &&
                              values.personalInfoDTO.keyPersonalInfoDTO
                                .addressProofType.shortName
                            )
                          }
                          infotext={t("keyPersonalInfo.aadharPdfInstruction")}
                          onFileUpload={onAddressProofUpload}
                          errorDescription={errorDescription}
                          base64FieldName={
                            "personalInfoDTO.keyPersonalInfoDTO.addressProofImage"
                          }
                          fileNameFieldName={
                            "personalInfoDTO.keyPersonalInfoDTO.addressProofFileName"
                          }
                          clearDependancyData={clearUploadDependancyData}
                          resettingBasedOnDependency={isResetting}
                          path={
                            "personalInfoDTO.keyPersonalInfoDTO.addressProofPath"
                          }
                        ></CsplDragDrop>
                      </div>

                      <div className="col-sm-11 col-12 mb-4 me-auto">
                        <CsplTextBoxField
                          label={"keyPersonalInfo.AddressLine1"}
                          name="personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentAddressLine1"
                          required={false}
                          disabled={isDisabled}
                          id="modifiedPermanentAddressLine1"
                          onBlur={onModifiedPermanentAddressLine1Change}
                        />
                      </div>

                      <div className="col-sm-11 col-12 mb-4 me-auto">
                        <CsplTextBoxField
                          label={"keyPersonalInfo.AddressLine2"}
                          name="personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentAddressLine2"
                          required={false}
                          disabled={isDisabled}
                          id="modifiedPermanentAddressLine2"
                          onBlur={onModifiedPermanentAddressLine2Change}
                        />
                      </div>

                      <div className="col-sm-11 col-12 mb-4 me-auto">
                        <CsplTextBoxField
                          label={"keyPersonalInfo.AddressLine3"}
                          name="personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentAddressLine3"
                          required={false}
                          disabled={isDisabled}
                          id="modifiedPermanentAddressLine3"
                          onBlur={onModifiedPermanentAddressLine3Change}
                        />
                      </div>

                      {/* Two Column Approach */}
                      <div className="col-sm-11 col-12 mb-4 me-auto">
                        <div className="d-md-flex justify-content-between">
                          <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                            <CsplTextBoxField
                              label={"keyPersonalInfo.City"}
                              name="personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentCity"
                              required={true}
                              disabled={isDisabled}
                              id="modifiedPermanentCity"
                              onBlur={onModifiedPermanentCityChange}
                            />
                          </div>

                          <div className="w-100">
                            <CsplAchField
                              label={"keyPersonalInfo.Country"}
                              name="personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentCountry"
                              required={true}
                              idColumn="id"
                              lookupName="country"
                              displayColumn="name"
                              disabled={isDisabled}
                              id="modifiedPermanentCountry"
                              getIdValue={setModifiedPermanentCountryId}
                              onValueChange={onModifiedPermanentCountryChange}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-11 col-12 mb-4 me-auto">
                        <div className="d-md-flex justify-content-between">
                          <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                            <CsplAchField
                              label={"keyPersonalInfo.State"}
                              name="personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentState"
                              idColumn="id"
                              required={true}
                              lookupName="state"
                              displayColumn="name"
                              disabled={isDisabled}
                              id="modifiedPermanentState"
                              filterValue={modifiedPermanentCountryId}
                              onValueChange={onModifiedPermanentStateChange}
                            />
                          </div>
                          <div className="w-100">
                            <CsplTextBoxField
                              label={"keyPersonalInfo.PinCode"}
                              name="personalInfoDTO.keyPersonalInfoDTO.modifiedPermanentPinCode"
                              required={true}
                              disabled={isDisabled}
                              id="modifiedPermanentPinCode"
                              onBlur={onModifiedPermanentPincodeChange}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                {/* Residential Address */}

                <div className="col-sm-11 col-12 mb-4 me-auto">
                  <CsplRadioButtonField
                    valuelist={radioValueList}
                    disabled={isDisabled}
                    rowdisplay={true}
                    label={
                      "keyPersonalInfo.residentialAddressSameAsPermanentAddress"
                    }
                    name="personalInfoDTO.keyPersonalInfoDTO.residentialAddressSameAsPermanentAddress"
                    onChange={residentialAddressHandler}
                    defaultValue={OptionsEnum.No}
                  ></CsplRadioButtonField>
                </div>

                {values &&
                  values.personalInfoDTO &&
                  values.personalInfoDTO.keyPersonalInfoDTO &&
                  values.personalInfoDTO.keyPersonalInfoDTO
                    .residentialAddressSameAsPermanentAddress &&
                  values.personalInfoDTO.keyPersonalInfoDTO
                    .residentialAddressSameAsPermanentAddress ===
                    OptionsEnum.No && (
                    <>
                      <div className="col-sm-11 col-12 mb-4 me-auto text-left">
                        <p className="sub_header_label">
                          {" "}
                          {t("keyPersonalInfo.residential-Address")}{" "}
                        </p>
                      </div>

                      <div className="col-sm-11 col-12 mb-4 me-auto">
                        <CsplTextBoxField
                          label={"keyPersonalInfo.AddressLine1"}
                          name="personalInfoDTO.keyPersonalInfoDTO.residentialAddressLine1"
                          required={false}
                          disabled={isDisabled}
                          id="residentialAddressLine1"
                        />
                      </div>

                      <div className="col-sm-11 col-12 mb-4 me-auto">
                        <CsplTextBoxField
                          label={"keyPersonalInfo.AddressLine2"}
                          name="personalInfoDTO.keyPersonalInfoDTO.residentialAddressLine2"
                          required={false}
                          disabled={isDisabled}
                          id="residentialAddressLine2"
                        />
                      </div>

                      <div className="col-sm-11 col-12 mb-4 me-auto">
                        <CsplTextBoxField
                          label={"keyPersonalInfo.AddressLine3"}
                          name="personalInfoDTO.keyPersonalInfoDTO.residentialAddressLine3"
                          required={false}
                          disabled={isDisabled}
                          id="residentialAddressLine3"
                        />
                      </div>

                      {/* Two Column Approach */}
                      <div className="col-sm-11 col-12 mb-4 me-auto">
                        <div className="d-md-flex justify-content-between">
                          <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                            <CsplTextBoxField
                              label={"keyPersonalInfo.City"}
                              name="personalInfoDTO.keyPersonalInfoDTO.residentialCity"
                              required={true}
                              disabled={isDisabled}
                              id="residentialCity"
                            />
                          </div>

                          <div className="w-100">
                            <CsplAchField
                              label={"keyPersonalInfo.Country"}
                              name="personalInfoDTO.keyPersonalInfoDTO.residentialCountry"
                              required={true}
                              idColumn="id"
                              lookupName="country"
                              displayColumn="name"
                              disabled={isDisabled}
                              id="residentialCountry"
                              getIdValue={setCountryId}
                              onValueChange={handleResidentialCountryChange}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-11 col-12 mb-4 me-auto">
                        <div className="d-md-flex justify-content-between">
                          <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                            <CsplAchField
                              label={"keyPersonalInfo.State"}
                              name="personalInfoDTO.keyPersonalInfoDTO.residentialState"
                              idColumn="id"
                              required={true}
                              lookupName="state"
                              displayColumn="name"
                              disabled={isDisabled}
                              id="residentialState"
                              filterValue={countryId}
                            />
                          </div>
                          <div className="w-100">
                            <CsplTextBoxField
                              label={"keyPersonalInfo.PinCode"}
                              name="personalInfoDTO.keyPersonalInfoDTO.residentialPinCode"
                              required={true}
                              disabled={isDisabled}
                              id="residentialPinCode"
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                {/* One Column Approach */}

                <div className="col-sm-11 col-12 mb-4 me-auto">
                  <div className="d-md-flex justify-content-between">
                    <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                      <CsplTextBoxField
                        label={"keyPersonalInfo.panNo"}
                        name="personalInfoDTO.keyPersonalInfoDTO.panNo"
                        required={true}
                        disabled={true}
                        id="panNo"
                      />
                    </div>
                    <div className="w-100"></div>
                  </div>
                </div>

                <div className="col-sm-11 col-12 mb-4 me-auto">
                  <div className="d-md-flex justify-content-between">
                    <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                      <CsplAchField
                        label={"keyPersonalInfo.gender"}
                        name="personalInfoDTO.keyPersonalInfoDTO.gender"
                        required={true}
                        idColumn="id"
                        lookupName="gender"
                        displayColumn="name"
                        disabled={true}
                        id="gender"
                      />
                    </div>
                    <div className="w-100"></div>
                  </div>
                </div>

                <div className="col-sm-11 col-12 mb-4 me-auto">
                  <div className="d-md-flex justify-content-between">
                    <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                      <CsplTextBoxField
                        label={"keyPersonalInfo.ckycNo"}
                        name="personalInfoDTO.keyPersonalInfoDTO.ckycNo"
                        required={false}
                        disabled={true}
                        id="ckycNo"
                      />
                    </div>
                    <div className="w-100"></div>
                  </div>

                  {/*Permanent Address Change*/}
                  <div className="col-sm-11 col-12 mb-4  mt-4 me-auto">
                    <CsplRadioButtonField
                      valuelist={radioValueList}
                      disabled={isDisabled}
                      rowdisplay={true}
                      label={"keyPersonalInfo.isDifferentlyAbled"}
                      name="personalInfoDTO.keyPersonalInfoDTO.isDifferentlyAbled"
                      onChange={handleDifferentlyAbled}
                      // defaultValue={OptionsEnum.No}
                      // defaultvaluedependencyhandler={
                      //   syncDifferentlyAbledVisibility
                      // }
                    />
                    <ErrorMessage
                      name="personalInfoDTO.keyPersonalInfoDTO.isDifferentlyAbled"
                      component="div"
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "5px",
                      }}
                    />
                  </div>
                  {showDisabilityFields && (
                    <div className="col-sm-11 col-12 mb-4 me-auto">
                      <div className="mb-4">
                        <CsplAchField
                          label={"keyPersonalInfo.impairmentType"}
                          name="personalInfoDTO.keyPersonalInfoDTO.impairmentTypeTagValue"
                          required={false}
                          lookupName="impairmentType"
                          displayColumn="name"
                          idColumn="id"
                          id="impairmenttype"
                          disabled={isDisabled}
                        />
                      </div>

                      <div className="mb-4">
                        <CsplNumberField
                          name="personalInfoDTO.keyPersonalInfoDTO.impairmentPercentage"
                          required={false}
                          label={"keyPersonalInfo.impairmentPercentage"}
                          disabled={isDisabled}
                          id="impairmentPercentage"
                        />
                      </div>
                      <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                        <CsplTextBoxField
                          label={"keyPersonalInfo.udidNo"}
                          name="personalInfoDTO.keyPersonalInfoDTO.udidNumber"
                          required={false}
                          disabled={isDisabled}
                          id="udidNo"
                        />
                      </div>
                      <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4 mt-4">
                        <CsplDragDrop
                          label={"keyPersonalInfo.impaimentFileUpload"}
                          required={false}
                          disabled={isDisabled}
                          base64FieldName={
                            "personalInfoDTO.keyPersonalInfoDTO.impairmentFileUploadDTO.impairmentProofFile"
                          }
                          fileNameFieldName={
                            "personalInfoDTO.keyPersonalInfoDTO.impairmentFileUploadDTO.impairmentProofFileName"
                          }
                          path={
                            "personalInfoDTO.keyPersonalInfoDTO.impairmentFileUploadDTO.impairmentProofFilePath"
                          }
                        ></CsplDragDrop>
                      </div>
                    </div>
                  )}
                </div>

                {/* Switch To Adhaar */}

                {applicationContext.currentWorkflow !== null &&
                  applicationContext.currentWorkflow.workflowDisplayName ===
                    WorkflowTypeEnum.CKYC &&
                  !applicationContext.disableForm && (
                    <>
                      <div className="col-lg-8 col-sm-11 col-12 mb-4 aadhaar-xml-link ">
                        <a
                          onClick={(e) => switchToAdhaar(e)}
                          className="btn shadow-none aadhaar-xml-btn p-0"
                        >
                          <CsplLabel label="keyPersonalInfo.switchToAdhaarText"></CsplLabel>
                        </a>

                        {clicked && (
                          <CsplBackDropLoading
                            showLoading={clicked}
                          ></CsplBackDropLoading>
                        )}
                        <div>
                          <span className="file_instruction">
                            {t("keyPersonalInfo.switchToAdhaarHelpText")}
                          </span>
                        </div>
                      </div>
                    </>
                  )}

                {mode && mode !== VIEW_MODE && (
                  <>
                    {" "}
                    <br /> <br /> <br />{" "}
                  </>
                )}

                {mode &&
                  mode === VIEW_MODE &&
                  values.personalInfoDTO &&
                  values.personalInfoDTO.keyPersonalInfoDTO &&
                  values.personalInfoDTO.keyPersonalInfoDTO
                    .matchedWithRegisteredName != null &&
                  props.value.personalInfoDTO &&
                  props.value.personalInfoDTO.keyPersonalInfoDTO && (
                    <div>
                      {
                        <div className="container border-0 padding-left-15">
                          <div className="row mb-5">
                            <PercentageComponent
                              percentText={
                                props.value.personalInfoDTO.keyPersonalInfoDTO
                                  .percentageMismatchInFullName
                              }
                              percentValue={
                                props.value.personalInfoDTO.keyPersonalInfoDTO
                                  .percentageMismatchInFullName
                              }
                              title={"keyPersonalInfo.fullName"}
                              ComparisonTitle={
                                "keyPersonalInfo.registeredFullName"
                              }
                              desc={true}
                              descTitle={"keyPersonalInfo.registeredFullName"}
                              descValue={
                                props.value.personalInfoDTO.keyPersonalInfoDTO
                                  .registeredFullName
                              }
                            />
                          </div>
                        </div>
                      }
                      <div className="col-sm-11 col-12 mb-4 me-auto">
                        <div className="d-md-flex justify-content-between">
                          <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                            <CsplLabel
                              label={
                                "keyPersonalInfo.isMatchedWithRegisteredName"
                              }
                            ></CsplLabel>
                            &nbsp;
                            <CsplLabel
                              label={
                                values.personalInfoDTO.keyPersonalInfoDTO
                                  .matchedWithRegisteredName != null
                                  ? values.personalInfoDTO.keyPersonalInfoDTO
                                      .matchedWithRegisteredName
                                    ? "Yes"
                                    : "No"
                                  : "-"
                              }
                            ></CsplLabel>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                {mode &&
                  mode === VIEW_MODE &&
                  values.personalInfoDTO &&
                  values.personalInfoDTO.keyPersonalInfoDTO &&
                  values.personalInfoDTO.keyPersonalInfoDTO
                    .matchedWithRegisteredName == null && (
                    <div className="container border-0 padding-left-15">
                      <div className="row mb-5">
                        <PercentageComponent
                          percentText={
                            props.value.personalInfoDTO.keyPersonalInfoDTO
                              .percentageMismatchInFirstName
                          }
                          percentValue={
                            props.value.personalInfoDTO.keyPersonalInfoDTO
                              .percentageMismatchInFirstName
                          }
                          title={"keyPersonalInfo.firstName"}
                          ComparisonTitle={"keyPersonalInfo.panFirstName"}
                          desc={true}
                          descTitle={"keyPersonalInfo.panFirstName"}
                          descValue={
                            props.value.personalInfoDTO.keyPersonalInfoDTO
                              .firstNameFromPan
                          }
                        />
                        <PercentageComponent
                          percentText={
                            props.value.personalInfoDTO.keyPersonalInfoDTO
                              .percentageMismatchInMiddleName
                          }
                          percentValue={
                            props.value.personalInfoDTO.keyPersonalInfoDTO
                              .percentageMismatchInMiddleName
                          }
                          title={"keyPersonalInfo.middleName"}
                          ComparisonTitle={"keyPersonalInfo.panMiddleName"}
                          desc={true}
                          descTitle={"keyPersonalInfo.panMiddleName"}
                          descValue={
                            props.value.personalInfoDTO.keyPersonalInfoDTO
                              .middleNameFromPan
                          }
                        />
                        <PercentageComponent
                          percentText={
                            props.value.personalInfoDTO.keyPersonalInfoDTO
                              .percentageMismatchInLastName
                          }
                          percentValue={
                            props.value.personalInfoDTO.keyPersonalInfoDTO
                              .percentageMismatchInLastName
                          }
                          title={"keyPersonalInfo.lastName"}
                          ComparisonTitle={"keyPersonalInfo.panLastName"}
                          desc={true}
                          descTitle={"keyPersonalInfo.panLastName"}
                          descValue={
                            props.value.personalInfoDTO.keyPersonalInfoDTO
                              .lastNameFromPan
                          }
                        />
                      </div>
                    </div>
                  )}
                {allowCKYCImageDetails() && (
                  <div className="col-sm-11 col-12 mb-4 me-auto text-left">
                    <p className="sub_header_label">
                      {" "}
                      {t("keyPersonalInfo.ckycImageDetails")}{" "}
                    </p>
                  </div>
                )}
                {
                  <Row>
                    {allowCKYCImageDetails() &&
                      values.personalInfoDTO.keyPersonalInfoDTO.ckycImageDetailsDTOList.map(
                        (imageObj, index) => {
                          return (
                            <Col sm={6} md={6} className="mb-5">
                              <CsplImage
                                imgUrl={
                                  imageObj.imageExtension.toUpperCase() ==
                                  FileTypeEnum.PDF
                                    ? "./Assets/Images/View_PDF_with_Help_Note_02.png"
                                    : "./Assets/Images/View_Image_With_Help_Note.png"
                                }
                                onClick={(event) =>
                                  ckycImageOnclickHandler(event, imageObj)
                                }
                              />
                              {previewCkycImage && (
                                <CsplPreviewModal
                                  showPreview={previewCkycImage}
                                  onClose={ckycImageOnCloseHandler}
                                  fileName={ckycImageFileName}
                                  base64String={ckycImageContent}
                                ></CsplPreviewModal>
                              )}
                              {/*  </div>
                          </div>
                        </div> */}
                            </Col>
                          );
                        },
                      )}
                  </Row>
                }
                <div></div>
              </div>
            )}
          </div>
        ) : (
          <div className="row">
            {applicationContext.currentWorkflow !== null &&
              applicationContext.currentWorkflow.workflowDisplayName ===
                WorkflowTypeEnum.AADHAAR &&
              !applicationContext.disableForm && (
                <div className="text-center">
                  <div className="col-xxl-3 col-xl-4 col-lg-5 col-md-5 col-sm-6 col-11 mb-4 mx-auto mt-5 getadhaardetails_two">
                    <a
                      onClick={(e) => getAadhaarDetails(e)}
                      className="btn shadow-none getadhaardetails_btn"
                    >
                      <CsplLabel label="keyPersonalInfo.downloadAadharDetailsText"></CsplLabel>
                    </a>

                    {clicked && (
                      <CsplBackDropLoading
                        showLoading={clicked}
                      ></CsplBackDropLoading>
                    )}
                    <div className="mt-3">
                      <span className="getadhaardetails_intruc">
                        {t("keyPersonalInfo.getAadhaarDetailsHelpText")}
                      </span>
                    </div>

                    <div></div>
                  </div>
                </div>
              )}
          </div>
        )}

        <div></div>
      </div>

      {/* </form>   */}
    </React.Fragment>
  );
}

export default KeyPersonalInfo;
